import { useEffect, useRef, ReactElement } from 'react';

import { logger } from '../../../core/Log/logger';

type ErrorFallbackProps = {
    children?: ReactElement;
    componentName: string;
    data: Record<string, unknown>;
    error: Error;
};
export function ErrorFallback({ children, ...props }: ErrorFallbackProps) {
    const propsRef = useRef(props);

    useEffect(() => {
        logger.error(`${propsRef.current.componentName} ErrorFallback`, {
            ...propsRef.current.data,
            error: propsRef.current.error,
        });
    }, []);

    return children;
}
